var React = require('react');

function Laptop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 0h71c2 0 3 .902 3 2.706V46H9V2.706C9 .902 10 0 12 0zM2 46h91c2 0 2 0 2 2s-2 2-5 2H5c-3 0-5 0-5-2s0-2 2-2z"}));
}

Laptop.defaultProps = {"viewBox":"0 0 95 50"};

module.exports = Laptop;

Laptop.default = Laptop;
